/**
 * @require ./tools.js
 */
(function (tools) {
    function getPropertyPath(identifier, useModified) {
        const dataSource = useModified ? changemode.Properties : Properties;
        let path;

        if (dataSource.hasOwnProperty(identifier)) {
            let parent = dataSource[identifier];

            if (!parent.Parent) {
                return '';
            }

            parent = parent.Parent;
            path = parent.Title;

            for (let i = 2; i > 0 && (parent = parent.Parent); i--) {
                path = '{0} &rsaquo; {1}'.format(parent.Title, path);
            }
        }

        return path;
    }

    function renderPropertyBadge(property) {
        if (!property) {
            return '';
        }

        const color = new Color(property.Color);
        const escapedTitle = Tools.escapeHtml(property.Title);

        return `
            <div class="property-badge"${property.Color ? `style="background-color:${property.Color};color:${color.getContrastTextColor()}"` : ''} title="${escapedTitle}">
                ${escapedTitle}
            </div>`;
    }

    tools.properties = {
        getPropertyPath: getPropertyPath,
        renderPropertyBadge: renderPropertyBadge
    };
})(window.Tools || (window.Tools = {}));